'use client'

import React from 'react'
import { getInt, getString } from './macro-parameter-extractor'
import { MacroProps } from './macro-props'
import { parse } from 'querystring'
import ProductListByCategoryPath from '@dustin-web/product-components/src/product-list-by-category-path'
import {
  getActiveFilters,
  parseParams,
} from '@dustin-web/microsite-components/src/utils/querystring'

export const MultipleProductBoxesByCategoryFilterPath = (props: MacroProps) => {
  // Example: /group/hardvara/datorer-surfplattor/barbara-datorer/apple/?screensize=13.3&installedmemorysize=8&typeofprocessor=m1&storagecapacityharddrive=256+256&showonly=instock&sortby=relevance
  const categoryFilterPath = getString('categoryfilterpath', props)

  //const preserveProductOrder = getBoolean('preserveproductorder', props)
  //const containerWidth = getInt('containerwidth', props, 8)
  const numberOfProducts = getInt('numberofproducts', props, 0)
  //const showOnlyCampaigns = getBoolean('showonlycampaigns', props)
  //const showOnlyNewProducts = getBoolean('showonlynewproducts', props)

  const url = new URL('http://temp.org' + (categoryFilterPath || '') ?? '')
  const categoryPath = url.pathname.replace('/group', '')

  const query = parse(categoryFilterPath.split('?')[1] ?? '')

  const queryParams = parseParams(query)

  const activeFilters = getActiveFilters(queryParams)

  return categoryPath ? (
    <ProductListByCategoryPath
      categoryPath={categoryPath}
      numberOfProducts={numberOfProducts}
      activeFilters={activeFilters}
      digitalDataOrigin="contentMacro"
      searchPhrase={queryParams['searchwithin'] || ''}
      sortBy={queryParams['sortby'] || 'relevance'}
    />
  ) : null
}

export default MultipleProductBoxesByCategoryFilterPath
